import api from '@/services/api'

export const getUserQuadrants = async (userId) => {
    try {
        const resp = await api.get(`users/${userId}/profile/quadrants`)
        return resp.data.data
    } catch (e) {
        console.log(e)
    }
}
